import React, { type ReactNode } from 'react';

import { useIntl } from 'react-intl-next';

import { cssMap, cx } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Bleed, Box } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';

type ContentMenuProps = {
	children?: ReactNode;
	heading?: ReactNode;
};

const styles = cssMap({
	root: {
		display: 'flex',
		flexDirection: 'column',
		maxHeight: `476px`,
		overflowY: 'auto',
		paddingLeft: token('space.100'),
		paddingRight: token('space.100'),
	},
	heading: {
		paddingBlock: token('space.075'),
		paddingLeft: token('space.075'),
		display: 'flex',
		alignItems: 'center',
	},
});

// MenuContent is responsible for defining a max-height for the menu content
// of the flyout menu. Heavily inspired by confluence's menu content componnet.
export const MenuContent = ({ children, heading }: ContentMenuProps): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<Bleed xcss={cx(styles.root)} inline="space.100">
			{heading && (
				<Box xcss={cx(styles.heading)}>
					<Heading size="xsmall" as="h2">
						{formatMessage(messages.sites, { productName: heading })}
					</Heading>
				</Box>
			)}
			{children}
		</Bleed>
	);
};
